import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from 'src/redesign/features/Account/store/constants';
import {
  fetchAccountApi,
  fetchConnectedAccountsApi,
  logoutApi,
  updateSelectedSiteApi,
} from 'src/redesign/features/Account/store/api';

export const getAccountInfo = createAsyncThunk(
  actionTypes.GET_ACCOUNT_INFO,
  async () => await fetchAccountApi()
);

export const getAccountConnected = createAsyncThunk(
  actionTypes.GET_CONNECTED_ACCOUNT_INFO,
  async (_, { getState }) => await fetchConnectedAccountsApi(getState())
);

export const updateSelectedSite = createAsyncThunk(
  actionTypes.UPDATE_SELECTED_SITE,
  async ({ siteId }: { siteId: string }) => await updateSelectedSiteApi(siteId)
);

export const logoutAccount = createAsyncThunk(actionTypes.LOGOUT, async () => await logoutApi());
